import React from "react";
import { Link } from "react-router-dom";
import { Button } from "react-toolbox/lib/button";

const LinkedButton = ({ to, replace, ...rest }) => (
  <Link to={to} replace={replace}>
    <Button {...rest} />
  </Link>
);

export default LinkedButton;
